(function () {
// eslint-disable-next-line max-len
var $0fb798a960d623b2$export$ef9d69bf459e1c38 = 'body--hidden';
var $0fb798a960d623b2$export$fe4c1de9841e7dd3 = 'menu--visible';
var $0fb798a960d623b2$export$d7968fa7a1c66a9e = 'menu';
var $0fb798a960d623b2$export$4d636c4ba967787a = 'menu-btn--close';
var $0fb798a960d623b2$export$4a212bf6130687f7 = 'menu-btn';
var $0fb798a960d623b2$export$a8a97846800a7d66 = 'language-selector';
var $0fb798a960d623b2$export$74d551a2466689cd = 'language-selector__button';
var $0fb798a960d623b2$export$2684fda514bedb82 = 'language-selector__button--hidden';
var $0fb798a960d623b2$export$6f734f043e171609 = 'language-selector__button--dropdown-visible';
var $0fb798a960d623b2$export$93f5f90183165e19 = 'language-selector__item';
var $0fb798a960d623b2$export$4bae433ca9d8b47 = 'language-selector__dropdown';
var $0fb798a960d623b2$export$9f6f34f6d129db5b = 'language-selector__dropdown--visible';
var $0fb798a960d623b2$export$c4da7678e43c6b2a = 'header__main-part';
var $0fb798a960d623b2$export$b115bd67a0d8747c = 'header__main-part--hidden';
var $0fb798a960d623b2$export$6e87ac3783225d6b = 'header__bottom-part';
var $0fb798a960d623b2$export$92ecefd04d80d83d = 'header__bottom-part--hidden';
var $0fb798a960d623b2$export$cd606794889c8984 = 'header';
var $0fb798a960d623b2$export$d2f2a1013c0c3033 = 'scroll-up-btn';
var $0fb798a960d623b2$export$947a61c9127a8280 = 'scroll-up-btn--visible';
var $0fb798a960d623b2$export$4ac068c328f2bfc4 = 'menuBtnOpen';
var $0fb798a960d623b2$export$8d094ccb1852c24d = 'menuBtnClose';
var $0fb798a960d623b2$export$1e9ee88f033039e9 = 300;
var $0fb798a960d623b2$export$72317f8505974a42 = 'language';
var $0fb798a960d623b2$export$292d61dcfb6174ec = 'ua';
var $0fb798a960d623b2$export$5f1ba54ed64fd212 = 'digest-subscribe';
var $0fb798a960d623b2$var$constants = {
    ANIMATION_DURATION: $0fb798a960d623b2$export$1e9ee88f033039e9,
    CLASS_BODY_HIDDEN: $0fb798a960d623b2$export$ef9d69bf459e1c38,
    CLASS_MENU_VISIBLE: $0fb798a960d623b2$export$fe4c1de9841e7dd3,
    CLASS_MENU_BTN_CLOSE: $0fb798a960d623b2$export$4d636c4ba967787a,
    DATA_TRANSLATE_MENU_OPEN: $0fb798a960d623b2$export$4ac068c328f2bfc4,
    DATA_TRANSLATE_MENU_CLOSE: $0fb798a960d623b2$export$8d094ccb1852c24d,
    LOCAL_STORAGE_LANGUAGE_KEY: $0fb798a960d623b2$export$72317f8505974a42,
    LANGUAGE_UA: $0fb798a960d623b2$export$292d61dcfb6174ec,
    CLASS_LANGUAGE_SELECTOR: $0fb798a960d623b2$export$a8a97846800a7d66,
    CLASS_LANGUAGE_SELECTOR_BUTTON: $0fb798a960d623b2$export$74d551a2466689cd,
    CLASS_LANGUAGE_SELECTOR_BUTTON_HIDDEN: $0fb798a960d623b2$export$2684fda514bedb82,
    CLASS_LANGUAGE_SELECTOR_BUTTON_DROPDOWN_VISIBLE: $0fb798a960d623b2$export$6f734f043e171609,
    CLASS_LANGUAGE_SELECTOR_ITEM: $0fb798a960d623b2$export$93f5f90183165e19,
    CLASS_LANGUAGE_SELECTOR_DROPDOWN: $0fb798a960d623b2$export$4bae433ca9d8b47,
    CLASS_LANGUAGE_SELECTOR_DROPDOWN_VISIBLE: $0fb798a960d623b2$export$9f6f34f6d129db5b,
    CLASS_MENU: $0fb798a960d623b2$export$d7968fa7a1c66a9e,
    CLASS_MENU_BTN: $0fb798a960d623b2$export$4a212bf6130687f7,
    CLASS_HEADER_MAIN_PART: $0fb798a960d623b2$export$c4da7678e43c6b2a,
    CLASS_HEADER_MAIN_PART_HIDDEN: $0fb798a960d623b2$export$b115bd67a0d8747c,
    CLASS_HEADER_BOTTOM_PART: $0fb798a960d623b2$export$6e87ac3783225d6b,
    CLASS_HEADER_BOTTOM_PART_HIDDEN: $0fb798a960d623b2$export$92ecefd04d80d83d,
    FORM_ID: $0fb798a960d623b2$export$5f1ba54ed64fd212,
    CLASS_SCROLL_UP_BTN: $0fb798a960d623b2$export$d2f2a1013c0c3033,
    CLASS_SCROLL_UP_BTN_VISIBLE: $0fb798a960d623b2$export$947a61c9127a8280,
    CLASS_HEADER: $0fb798a960d623b2$export$cd606794889c8984
};
var $0fb798a960d623b2$export$2e2bcd8739ae039 = $0fb798a960d623b2$var$constants;



var $3ad91079be1c7c57$export$79c0f9d0f5163be1 = document.querySelector('.' + (0, $0fb798a960d623b2$export$a8a97846800a7d66));
var $3ad91079be1c7c57$export$37fa52dd6db13025 = $3ad91079be1c7c57$export$79c0f9d0f5163be1.querySelector('.' + (0, $0fb798a960d623b2$export$74d551a2466689cd));
var $3ad91079be1c7c57$export$734b6b18d6fd8950 = $3ad91079be1c7c57$export$79c0f9d0f5163be1.querySelector('.' + (0, $0fb798a960d623b2$export$4bae433ca9d8b47));
var $3ad91079be1c7c57$export$3d4a40cd190e3ce0 = $3ad91079be1c7c57$export$734b6b18d6fd8950.querySelectorAll('.' + (0, $0fb798a960d623b2$export$93f5f90183165e19));
var $3ad91079be1c7c57$export$14a1b2c8db03d24a = document.querySelector('.' + (0, $0fb798a960d623b2$export$4a212bf6130687f7));
var $3ad91079be1c7c57$export$b1e5508a851be14d = document.querySelector('.' + (0, $0fb798a960d623b2$export$d7968fa7a1c66a9e));
var $3ad91079be1c7c57$export$38e42c68cf43b5d4 = document.querySelector('.' + (0, $0fb798a960d623b2$export$cd606794889c8984));
var $3ad91079be1c7c57$export$2600bcb6839597dc = document.querySelector('.' + (0, $0fb798a960d623b2$export$c4da7678e43c6b2a));
var $3ad91079be1c7c57$export$4a256d9e3d0e0bc0 = document.querySelector('.' + (0, $0fb798a960d623b2$export$6e87ac3783225d6b));
var $3ad91079be1c7c57$export$8110b902d5298ede = document.querySelector('.' + (0, $0fb798a960d623b2$export$d2f2a1013c0c3033));
var $3ad91079be1c7c57$export$6210fa4921d2a466 = document.getElementById((0, $0fb798a960d623b2$export$5f1ba54ed64fd212));
var $3ad91079be1c7c57$export$d675b3969e4857cb = $3ad91079be1c7c57$export$6210fa4921d2a466.querySelector('button[type="submit"]');
var $3ad91079be1c7c57$export$326bce2259f858eb = $3ad91079be1c7c57$export$6210fa4921d2a466.querySelector('input[type="email"]');
var $3ad91079be1c7c57$var$elements = {
    languageSelector: $3ad91079be1c7c57$export$79c0f9d0f5163be1,
    languageSelectorButton: $3ad91079be1c7c57$export$37fa52dd6db13025,
    languageSelectorDropdown: $3ad91079be1c7c57$export$734b6b18d6fd8950,
    languageSelectorItems: $3ad91079be1c7c57$export$3d4a40cd190e3ce0,
    menuBtn: $3ad91079be1c7c57$export$14a1b2c8db03d24a,
    menu: $3ad91079be1c7c57$export$b1e5508a851be14d,
    headerMainPart: $3ad91079be1c7c57$export$2600bcb6839597dc,
    headerBottomPart: $3ad91079be1c7c57$export$4a256d9e3d0e0bc0,
    form: $3ad91079be1c7c57$export$6210fa4921d2a466,
    submitButton: $3ad91079be1c7c57$export$d675b3969e4857cb
};
var $3ad91079be1c7c57$export$2e2bcd8739ae039 = $3ad91079be1c7c57$var$elements;


var $c745b4b91eb85d3a$export$9ed8616c3160d4b = function(e) {
    e.preventDefault();
    (0, $3ad91079be1c7c57$export$326bce2259f858eb).setAttribute('disabled', 'true');
    (0, $3ad91079be1c7c57$export$d675b3969e4857cb).setAttribute('disabled', 'true');
    setTimeout(function() {
        (0, $3ad91079be1c7c57$export$6210fa4921d2a466).reset();
        (0, $3ad91079be1c7c57$export$326bce2259f858eb).removeAttribute('disabled');
        (0, $3ad91079be1c7c57$export$d675b3969e4857cb).removeAttribute('disabled');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, (0, $0fb798a960d623b2$export$1e9ee88f033039e9));
};
var $c745b4b91eb85d3a$export$b7feb3e146f9297f = function() {
    (0, $3ad91079be1c7c57$export$6210fa4921d2a466).addEventListener('submit', $c745b4b91eb85d3a$export$9ed8616c3160d4b);
};


// eslint-disable-next-line max-len

'use strict';
var $2efcc2a8e9aa1010$var$translations = {
    ua: {
        logo: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E\u0433\u043E\u0440\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438"
        },
        menuBtnOpen: {
            attr: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0431\u0456\u0447\u043D\u0435 \u043C\u0435\u043D\u044E"
        },
        menuBtnClose: {
            attr: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u0431\u0456\u0447\u043D\u0435 \u043C\u0435\u043D\u044E"
        },
        languageSelector__button: {
            attr: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430, \u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043C\u043E\u0432\u0443"
        },
        langugageSlector__description: {
            text: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u043E\u0432\u0443"
        },
        headerDates: {
            text: "10 \u0441\u0435\u0440\u043F\u043D\u044F - 10 \u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430"
        },
        headerTitle: {
            text: "\u041C\u0438\u0441\u0442\u0435\u0446\u0442\u0432\u043E \u0425\u0406\u0425 - \u0425\u0425 \u0441\u0442."
        },
        headerDescription: {
            text: "\u0412\u043D\u0435\u0441\u043E\u043A \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0438\u0445 \u043C\u0438\u0442\u0446\u0456\u0432 \u0443 \u0441\u0432\u0456\u0442\u043E\u0432\u0443 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0443 19-20 \u0441\u0442."
        },
        buyTicketButton: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0437\u0438\u0442\u0443",
            text: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0438\u0442\u043E\u043A"
        },
        menuSheduleLabel: {
            text: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456"
        },
        menuAddressLabel: {
            text: "\u0410\u0434\u0440\u0435\u0441\u0430:"
        },
        menuAddressText: {
            text: "\u041A\u0438\u0457\u0432, \u0432\u0443\u043B. \u041C. \u0413\u0440\u0443\u0448\u0435\u0432\u0441\u044C\u043A\u043E\u0433\u043E, 6"
        },
        menuExhibitions: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043E\u043A",
            text: "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0456 \u0432\u0438\u0441\u0442\u0430\u0432\u043A\u0438"
        },
        menuNews: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043D\u043E\u0432\u0438\u043D",
            text: "\u041D\u043E\u0432\u0438\u043D\u0438"
        },
        menuEvents: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043F\u043E\u0434\u0456\u0439",
            text: "\u041D\u0430\u0439\u0431\u043B\u0438\u0436\u0447\u0456 \u043F\u043E\u0434\u0456\u0457"
        },
        actualExhibitionsTitle: {
            text: "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0456 \u0432\u0438\u0441\u0442\u0430\u0432\u043A\u0438"
        },
        exhibitionTitleAngels: {
            text: "\u041A\u0443\u0440\u0430\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0432\u0438\u0441\u0442\u0430\u0432\u043A\u0430 \u201C\u0410\u043D\u0433\u0435\u043B\u0438\u201D"
        },
        exhibitionDescriptionAngels: {
            text: "\u0412\u0438\u0441\u0442\u0430\u0432\u043A\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0435\u043A\u0442 \xab\u0410\u043D\u0433\u0435\u043B\u0438\xbb \u2013 \u0437\u043D\u0430\u043A\u043E\u0432\u0430 \u043F\u043E\u0434\u0456\u044F \u0434\u043B\u044F \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u0457 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0438 \u0456 \u0432\u043E\u0434\u043D\u043E\u0447\u0430\u0441 \u043D\u0430\u0439\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u043D\u0456\u0448\u0438\u0439..."
        },
        exhibitionDatesArt: {
            text: "\u0414\u0456\u0454 \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u043E"
        },
        exhibitionTitleArt: {
            text: "\u041C\u0438\u0441\u0442\u0435\u0446\u0442\u0432\u043E \u0425\u0425 \u0441\u0442. \u2014 XXI \u0441\u0442."
        },
        exhibitionDescriptionArt: {
            text: "\u0417\u043D\u0430\u043A\u043E\u0432\u0456 \u0440\u043E\u0431\u043E\u0442\u0438 \u0410\u043B\u043B\u0438 \u0413\u043E\u0440\u0441\u044C\u043A\u043E\u0457, \u041C\u0438\u043A\u043E\u043B\u0438 \u0421\u0430\u043C\u043E\u043A\u0438\u0448\u0430, \u0424\u0435\u0434\u043E\u0440\u0430 \u041A\u0440\u0438\u0447\u0435\u0432\u0441\u044C\u043A\u043E\u0433\u043E \u0442\u0430 \u0456\u043D\u0448\u0438\u0445 \u043C\u0438\u0442\u0446\u0456\u0432."
        },
        goToArchiveExhibitionsButton: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0430\u0440\u0445\u0456\u0432\u0443 \u0432\u0438\u0441\u0442\u0430\u0432\u043E\u043A",
            text: "\u0410\u0440\u0445\u0456\u0432 \u0432\u0438\u0441\u0442\u0430\u0432\u043E\u043A"
        },
        eventsTitle: {
            text: "\u041D\u0430\u0439\u0431\u043B\u0438\u0436\u0447\u0456 \u043F\u043E\u0434\u0456\u0457"
        },
        eventRegisterButton: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0437\u0438\u0442\u0443",
            text: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F"
        },
        eventTitleExcursion: {
            text: "\u041A\u0443\u0440\u0430\u0442\u043E\u0440\u0441\u044C\u043A\u0456 \u0435\u043A\u0441\u043A\u0443\u0440\u0441\u0456\u0457 \u0432\u0456\u0434 \u041F\u0430\u0432\u043B\u0430 \u0413\u0443\u0434\u0456\u043C\u043E\u0432\u0430"
        },
        eventDescriptionExcursion: {
            text: "\u0422\u0430\u0454\u043C\u043D\u0438\u0446\u0456 \u043F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438, \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u0435\u043A\u0441\u043F\u043E\u043D\u0430\u0442\u0456\u0432, \u043C\u0430\u0433\u0456\u044F \u0434\u0456\u0439\u0441\u0442\u0432\u0430 \u0434\u043E \u0456 \u0432 \u043C\u043E\u043C\u0435\u043D\u0442 \u0432\u0430\u0448\u043E\u0457 \u043F\u0440\u0438\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456 \u2013 \u0440\u043E\u0437\u0433\u043E\u0440\u0442\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F..."
        },
        eventDatesExcursion: {
            text: "14.08 \u043E 13:00"
        },
        eventDatesMasterClass: {
            text: "16.08 \u043E 13:00"
        },
        eventTitleMasterClass: {
            text: "\u041C\u0430\u0439\u0441\u0442\u0435\u0440-\u043A\u043B\u0430\u0441 \u201C\u041F\u043E\u0434\u043E\u0440\u043E\u0436 \u0434\u043E \u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u0457\u201D"
        },
        eventDescriptionMasterClass: {
            text: "\u0426\u0456\u0454\u0457 \u043D\u0435\u0434\u0456\u043B\u0456 \u043E 14:00 \u043D\u0430 \u0430\u0440\u0442-\u043C\u0430\u043D\u0434\u0440\u0456\u0432\u043D\u0438\u043A\u0456\u0432 \u0447\u0435\u043A\u0430\u0454 \u043E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043F\u0443\u043D\u043A\u0442 \u043A\u0440\u0443\u0433\u043E\u0441\u0432\u0456\u0442\u043D\u044C\u043E\u0457 \u043F\u043E\u0434\u043E\u0440\u043E\u0436\u0456 - \u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F."
        },
        goToEventCalendar: {
            text: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 \u043F\u043E\u0434\u0456\u0439",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F \u043F\u043E\u0434\u0456\u0439"
        },
        planVisitTitle: {
            text: "\u0421\u043F\u043B\u0430\u043D\u0443\u0439\u0442\u0435 \u0432\u0456\u0437\u0438\u0442 \u0434\u043E \u043C\u0443\u0437\u0435\u044E"
        },
        planVisitDescription: {
            text: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0437\u0440\u0443\u0447\u043D\u0438\u0439 \u0434\u0435\u043D\u044C, \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u043D\u0430 \u043F\u043E\u0434\u0456\u0457, \u0449\u043E \u0446\u0456\u043A\u0430\u0432\u043B\u044F\u0442\u044C, \u043A\u0443\u043F\u0456\u0442\u044C \u043A\u0432\u0438\u0442\u043E\u043A \u0437\u0430\u0437\u0434\u0430\u043B\u0435\u0433\u0456\u0434\u044C, \u0449\u043E\u0431 \u043D\u0456\u0449\u043E \u043D\u0435 \u0437\u0430\u0432\u0430\u0434\u0438\u043B\u043E \u0432\u0430\u043C \u043D\u0430\u0441\u043E\u043B\u043E\u0434\u0436\u0443\u0432\u0430\u0442\u0438\u0441\u044C \u043C\u0438\u0441\u0442\u0435\u0446\u0442\u0432\u043E\u043C."
        },
        planVisitButton: {
            text: "\u041F\u043E\u0447\u0430\u0442\u0438",
            attr: "\u041F\u043E\u0447\u0430\u0442\u0438 \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0437\u0438\u0442\u0443"
        },
        newsTitle: {
            text: "\u041D\u043E\u0432\u0438\u043D\u0438"
        },
        newsAnnouncementWinnerTitle: {
            text: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u043C\u043E\u0436\u0446\u044F"
        },
        newsAnnouncementWinnerDates: {
            text: "9 \u0441\u0435\u0440\u043F\u043D\u044F 2019"
        },
        newsAnnouncementWinnerDescription: {
            text: "\u0414\u0440\u0443\u0437\u0456, \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043F'\u044F\u0442\u043D\u0438\u0446\u044F! \u0410 \u0446\u0435 \u043E\u0437\u043D\u0430\u0447\u0430\u0454, \u0449\u043E \u0447\u0430\u0441 \u043E\u0433\u043E\u043B\u043E\u0441\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u043C\u043E\u0436\u0446\u044F \u0440\u043E\u0437\u0456\u0433\u0440\u0430\u0448\u0443..."
        },
        newsInternationalCatDayTitle: {
            text: "\u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u0434\u0435\u043D\u044C \u043A\u043E\u0442\u0456\u0432"
        },
        newsInternationalCatDayDates: {
            text: "9 \u0441\u0435\u0440\u043F\u043D\u044F 2019"
        },
        newsInternationalCatDayDescription: {
            text: "\u041C\u0443\u0437\u0435\u0439 \u0437 \u043B\u0435\u0432\u0430\u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u0440\u043E\u0441\u0442\u043E \u0442\u0430\u043A \u0432\u0437\u044F\u0442\u0438 \u0456 \u043F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438 \u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u0434\u0435\u043D\u044C \u043A\u043E\u0442\u0456\u0432!"
        },
        goToAllNewsButton: {
            text: "\u0423\u0441\u0456 \u043D\u043E\u0432\u0438\u043D\u0438",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0432\u0441\u0456\u0445 \u043D\u043E\u0432\u0438\u043D"
        },
        digestSubscribeTitle: {
            text: "\u041F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0434\u0430\u0439\u0434\u0436\u0435\u0441\u0442"
        },
        digestSubscribeDescription: {
            text: "\u041F\u0435\u0440\u0448\u0438\u043C\u0438 \u0434\u0456\u0437\u043D\u0430\u0432\u0430\u0439\u0442\u0435\u0441\u044C \u043F\u0440\u043E \u043D\u043E\u0432\u0438\u043D\u0438 \u043C\u0443\u0437\u0435\u044E \u0442\u0430 \u0440\u043E\u0437\u0456\u0433\u0440\u0430\u0448\u0456, \u043E\u0442\u0440\u0438\u043C\u0443\u0439\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0434\u0456\u0457 \u0442\u0430 \u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0441\u0442\u0430\u0442\u0442\u0456 \u0432\u0456\u0434 \u043A\u0443\u0440\u0430\u0442\u043E\u0440\u0456\u0432"
        },
        digestSubscribeButton: {
            text: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044C",
            attr: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044F \u043D\u0430 \u0434\u0430\u0439\u0434\u0436\u0435\u0441\u0442"
        },
        digestSubscribeInput: {
            attr: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443"
        },
        contactsTitle: {
            text: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438"
        },
        contactsAddress: {
            text: "\u041A\u0438\u0457\u0432,<br/>\u0432\u0443\u043B. \u041C. \u0413\u0440\u0443\u0448\u0435\u0432\u0441\u044C\u043A\u043E\u0433\u043E, 6",
            attr: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456"
        },
        contactsTel: {
            text: "\u0442\u0435\u043B."
        },
        contactsPhone: {
            attr: "\u041F\u043E\u0434\u0437\u0432\u043E\u043D\u0438\u0442\u0438 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0443"
        },
        contactsEmail: {
            attr: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043D\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443"
        },
        contactsFacebook: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0443 Facebook"
        },
        contactsX: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0443 X"
        },
        contactsInstagram: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0443 Instagram"
        },
        contactsTelegram: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0443 \u0433\u0440\u0443\u043F\u0443 \u0443 Telegram"
        },
        workS\u0441heduleTitle: {
            text: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434 \u0440\u043E\u0431\u043E\u0442\u0438"
        },
        workScheduleDetails: {
            text: "\u041F\u041D: \u0432\u0438\u0445\u0456\u0434\u043D\u0438\u0439<br/>\n              \u0412\u0422: \u0432\u0438\u0445\u0456\u0434\u043D\u0438\u0439<br/>\n              \u0421\u0420: 10:00 - 17:00<br/>\n              \u0427\u0422: 10:00 - 17:00<br/>\n              \u041F\u0422: 12:00 - 19:00<br/>\n              \u0421\u0411: 11:00 - 18:00<br/>\n              \u041D\u0414: 10:00 - 17:00<br/>"
        },
        footerMainLink: {
            text: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043E\u043B\u043E\u0432\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443"
        },
        footerExhibitionsLink: {
            text: "\u0412\u0438\u0441\u0442\u0430\u0432\u043A\u0438",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043E\u043A"
        },
        footerNewsLink: {
            text: "\u041D\u043E\u0432\u0438\u043D\u0438",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043D\u043E\u0432\u0438\u043D"
        },
        footerEventsLink: {
            text: "\u041F\u043E\u0434\u0456\u0457",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043F\u043E\u0434\u0456\u0439"
        },
        footerHome: {
            text: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043E\u043B\u043E\u0432\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443"
        },
        footerExhibitions: {
            text: "\u0412\u0438\u0441\u0442\u0430\u0432\u043A\u0438",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043E\u043A"
        },
        footerEvents: {
            text: "\u041F\u043E\u0434\u0456\u0457",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043F\u043E\u0434\u0456\u0439"
        },
        footerNews: {
            text: "\u041D\u043E\u0432\u0438\u043D\u0438",
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043D\u043E\u0432\u0438\u043D"
        },
        footerPrivacy: {
            attr: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043F\u043E\u043B\u0456\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u043E\u0441\u0442\u0456"
        },
        goToTopButton: {
            attr: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E\u0433\u043E\u0440\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438"
        }
    },
    en: {
        logo: {
            attr: 'Go to top of the page'
        },
        menuBtnOpen: {
            attr: 'Open side menu'
        },
        menuBtnClose: {
            attr: 'Close side menu'
        },
        languageSelector__button: {
            attr: 'English, Select language'
        },
        langugageSlector__description: {
            text: 'Choose your language'
        },
        headerDates: {
            text: 'August 10 - November 10'
        },
        headerTitle: {
            text: '19th-20th Century Art'
        },
        headerDescription: {
            text: "Contribution of Ukrainian artists to world culture of the 19-20 centuries."
        },
        buyTicketButton: {
            attr: 'Go to planning a visit',
            text: 'Buy a ticket'
        },
        menuSheduleLabel: {
            text: "Today's schedule"
        },
        menuAddressLabel: {
            text: 'Address:'
        },
        menuAddressText: {
            text: 'Kyiv, 6, M. Hrushevskoho St.'
        },
        menuExhibitions: {
            attr: 'Go to exhibitions',
            text: 'Current exhibitions'
        },
        menuNews: {
            attr: 'Go to news',
            text: 'News'
        },
        menuEvents: {
            attr: 'Go to events',
            text: 'Upcoming events'
        },
        actualExhibitionsTitle: {
            text: 'Current exhibitions'
        },
        exhibitionTitleAngels: {
            text: "Curatorial exhibition \u201CAngels\u201D"
        },
        exhibitionDescriptionAngels: {
            text: 'The exhibition project "Angels" is a landmark event for Ukrainian culture and at the same time the largest...'
        },
        exhibitionDatesArt: {
            text: 'Is permanent'
        },
        exhibitionTitleArt: {
            text: '19th-20th Century Art'
        },
        exhibitionDescriptionArt: {
            text: "Iconic works by Alla Horska, Mykola Samokysh, Fedir Krychevsky and other artists."
        },
        goToArchiveExhibitionsButton: {
            attr: 'Go to the archive of exhibitions',
            text: 'Exhibition archive'
        },
        eventsTitle: {
            text: 'Upcoming events'
        },
        eventRegisterButton: {
            attr: 'Go to planning a visit',
            text: 'Register'
        },
        eventTitleExcursion: {
            text: 'Curatorial excursions by Pavlo Hudymov'
        },
        eventDescriptionExcursion: {
            text: "Secrets of preparation, stories of exhibits, the magic of the action before and during your presence - will unfold..."
        },
        eventDatesExcursion: {
            text: 'August 14 at 13:00'
        },
        eventDatesMasterClass: {
            text: 'August 16 at 13:00'
        },
        eventTitleMasterClass: {
            text: "Master class \u201CJourney to Australia\u201D"
        },
        eventDescriptionMasterClass: {
            text: "This Sunday at 14:00, art travelers will have the last point of a round-the-world trip - Australia."
        },
        goToEventCalendar: {
            text: 'Events calendar',
            attr: 'Go to events calendar'
        },
        planVisitTitle: {
            text: 'Plan your visit to the museum'
        },
        planVisitDescription: {
            text: "Choose a convenient day, register for events that interest you, buy a ticket in advance so that nothing prevents you from enjoying art."
        },
        planVisitButton: {
            text: 'Start',
            attr: 'Start planning a visit'
        },
        newsTitle: {
            text: 'News'
        },
        newsAnnouncementWinnerTitle: {
            text: 'Winner announcement'
        },
        newsAnnouncementWinnerDates: {
            text: 'August 9, 2019'
        },
        newsAnnouncementWinnerDescription: {
            text: "Friends, today is Friday! And this means that it's time to announce the winner of the drawing..."
        },
        newsInternationalCatDayTitle: {
            text: 'International Cat Day'
        },
        newsInternationalCatDayDates: {
            text: 'August 9, 2019'
        },
        newsInternationalCatDayDescription: {
            text: "A museum with lions cannot just ignore International Cat Day!"
        },
        goToAllNewsButton: {
            text: 'All news',
            attr: 'Go to all news'
        },
        digestSubscribeTitle: {
            text: 'Subscribe to the digest'
        },
        digestSubscribeDescription: {
            text: "Be the first to learn about museum news and drawings, receive invitations to events and read articles from curators"
        },
        digestSubscribeButton: {
            text: 'Subscribe',
            attr: 'Subscribe to the digest'
        },
        digestSubscribeInput: {
            attr: 'Enter your email'
        },
        contactsTitle: {
            text: 'Contacts'
        },
        contactsAddress: {
            text: 'Kyiv,<br/>M. Hrushevskoho St., 6',
            attr: 'Show on map'
        },
        contactsTel: {
            text: 'tel.'
        },
        contactsPhone: {
            attr: 'Call the manager'
        },
        contactsEmail: {
            attr: 'Write an email'
        },
        contactsFacebook: {
            attr: 'Go to the official Facebook page'
        },
        contactsX: {
            attr: 'Go to the official X page'
        },
        contactsInstagram: {
            attr: 'Go to the official Instagram page'
        },
        contactsTelegram: {
            attr: 'Go to the official Telegram group'
        },
        workS\u0441heduleTitle: {
            text: 'Work schedule'
        },
        workScheduleDetails: {
            text: "Mon: day off<br/>\n              Tue: day off<br/>\n              Wed: 10:00 - 17:00<br/>\n              Thu: 10:00 - 17:00<br/>\n              Fri: 12:00 - 19:00<br/>\n              Sat: 11:00 - 18:00<br/>\n              Sun: 10:00 - 17:00<br/>"
        },
        footerMainLink: {
            text: 'Main',
            attr: 'Go to the main page'
        },
        footerExhibitionsLink: {
            text: 'Exhibitions',
            attr: 'Go to exhibitions'
        },
        footerNewsLink: {
            text: 'News',
            attr: 'Go to news'
        },
        footerEventsLink: {
            text: 'Events',
            attr: 'Go to events'
        },
        footerHome: {
            text: 'Main',
            attr: 'Go to the main page'
        },
        footerExhibitions: {
            text: 'Exhibitions',
            attr: 'Go to exhibitions'
        },
        footerEvents: {
            text: 'Events',
            attr: 'Go to events'
        },
        footerNews: {
            text: 'News',
            attr: 'Go to news'
        },
        footerPrivacy: {
            attr: 'Go to the privacy policy'
        },
        goToTopButton: {
            attr: 'Go to top of the page'
        }
    }
};
var $2efcc2a8e9aa1010$export$2e2bcd8739ae039 = $2efcc2a8e9aa1010$var$translations;




var $36cad142eb79f92e$export$3fb77973914a03c8 = function() {
    var currentLanguage = localStorage.getItem((0, $0fb798a960d623b2$export$72317f8505974a42)) || (0, $0fb798a960d623b2$export$292d61dcfb6174ec);
    var menuBtnOpenText = (0, $2efcc2a8e9aa1010$export$2e2bcd8739ae039)[currentLanguage][0, $0fb798a960d623b2$export$4ac068c328f2bfc4].attr;
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('data-translate', (0, $0fb798a960d623b2$export$4ac068c328f2bfc4));
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('aria-label', menuBtnOpenText);
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('title', menuBtnOpenText);
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('href', '#menu');
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).classList.remove((0, $0fb798a960d623b2$export$4d636c4ba967787a));
};
var $36cad142eb79f92e$export$ba16b4d589d0cb5c = function() {
    var currentLanguage = localStorage.getItem((0, $0fb798a960d623b2$export$72317f8505974a42)) || (0, $0fb798a960d623b2$export$292d61dcfb6174ec);
    var menuBtnCloseText = (0, $2efcc2a8e9aa1010$export$2e2bcd8739ae039)[currentLanguage][0, $0fb798a960d623b2$export$8d094ccb1852c24d].attr;
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('data-translate', (0, $0fb798a960d623b2$export$8d094ccb1852c24d));
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('aria-label', menuBtnCloseText);
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('title', menuBtnCloseText);
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).setAttribute('href', '#');
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).classList.add((0, $0fb798a960d623b2$export$4d636c4ba967787a));
};
var $36cad142eb79f92e$export$978857af675b1906 = function() {
    (0, $3ad91079be1c7c57$export$b1e5508a851be14d).classList.add((0, $0fb798a960d623b2$export$fe4c1de9841e7dd3));
    (0, $3ad91079be1c7c57$export$b1e5508a851be14d).style.visibility = 'visible';
};
var $36cad142eb79f92e$export$cdf0b0ed532145ff = function() {
    (0, $3ad91079be1c7c57$export$b1e5508a851be14d).classList.remove((0, $0fb798a960d623b2$export$fe4c1de9841e7dd3));
    setTimeout(function() {
        (0, $3ad91079be1c7c57$export$b1e5508a851be14d).style.visibility = 'hidden';
    }, (0, $0fb798a960d623b2$export$1e9ee88f033039e9));
};
var $36cad142eb79f92e$export$436f07e526c01bfe = function() {
    return (0, $3ad91079be1c7c57$export$b1e5508a851be14d).classList.contains((0, $0fb798a960d623b2$export$fe4c1de9841e7dd3));
};
var $36cad142eb79f92e$export$4e13d164f2b2aea = function() {
    if (!(0, $3ad91079be1c7c57$export$2600bcb6839597dc).classList.contains((0, $0fb798a960d623b2$export$b115bd67a0d8747c))) {
        (0, $3ad91079be1c7c57$export$2600bcb6839597dc).classList.add((0, $0fb798a960d623b2$export$b115bd67a0d8747c));
        setTimeout(function() {
            (0, $3ad91079be1c7c57$export$2600bcb6839597dc).style.visibility = 'hidden';
        }, (0, $0fb798a960d623b2$export$1e9ee88f033039e9));
    }
    if (!(0, $3ad91079be1c7c57$export$4a256d9e3d0e0bc0).classList.contains((0, $0fb798a960d623b2$export$92ecefd04d80d83d))) {
        (0, $3ad91079be1c7c57$export$4a256d9e3d0e0bc0).classList.add((0, $0fb798a960d623b2$export$92ecefd04d80d83d));
        setTimeout(function() {
            (0, $3ad91079be1c7c57$export$4a256d9e3d0e0bc0).style.visibility = 'hidden';
        }, (0, $0fb798a960d623b2$export$1e9ee88f033039e9));
    }
};
var $36cad142eb79f92e$export$654031a515423eb1 = function() {
    if ((0, $3ad91079be1c7c57$export$2600bcb6839597dc).classList.contains((0, $0fb798a960d623b2$export$b115bd67a0d8747c))) {
        (0, $3ad91079be1c7c57$export$2600bcb6839597dc).classList.remove((0, $0fb798a960d623b2$export$b115bd67a0d8747c));
        (0, $3ad91079be1c7c57$export$2600bcb6839597dc).style.visibility = 'visible';
    }
    if ((0, $3ad91079be1c7c57$export$4a256d9e3d0e0bc0).classList.contains((0, $0fb798a960d623b2$export$92ecefd04d80d83d))) {
        (0, $3ad91079be1c7c57$export$4a256d9e3d0e0bc0).classList.remove((0, $0fb798a960d623b2$export$92ecefd04d80d83d));
        (0, $3ad91079be1c7c57$export$4a256d9e3d0e0bc0).style.visibility = 'visible';
    }
};
var $36cad142eb79f92e$var$hideMenuRevealHeader = function() {
    $36cad142eb79f92e$export$3fb77973914a03c8();
    $36cad142eb79f92e$export$cdf0b0ed532145ff();
    $36cad142eb79f92e$export$654031a515423eb1();
};
var $36cad142eb79f92e$var$revealMenuHideHeader = function() {
    $36cad142eb79f92e$export$ba16b4d589d0cb5c();
    $36cad142eb79f92e$export$978857af675b1906();
    $36cad142eb79f92e$export$4e13d164f2b2aea();
};
var $36cad142eb79f92e$export$2ed0d87888e94537 = function(e) {
    if ((0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).classList.contains((0, $0fb798a960d623b2$export$4d636c4ba967787a))) $36cad142eb79f92e$var$hideMenuRevealHeader();
    else $36cad142eb79f92e$var$revealMenuHideHeader();
};
var $36cad142eb79f92e$var$handleDocumentClick = function(e) {
    if (e.target.tagName === 'A' && (0, $3ad91079be1c7c57$export$b1e5508a851be14d).classList.contains((0, $0fb798a960d623b2$export$fe4c1de9841e7dd3))) $36cad142eb79f92e$var$hideMenuRevealHeader();
};
var $36cad142eb79f92e$export$cd1ed5fb42567c5c = function() {
    (0, $3ad91079be1c7c57$export$14a1b2c8db03d24a).addEventListener('click', function() {
        $36cad142eb79f92e$export$2ed0d87888e94537();
        (0, $ba554c72d1debec3$export$135d2e681114b0c3)();
    });
    document.addEventListener('click', $36cad142eb79f92e$var$handleDocumentClick);
};





'use strict';
function $e7426fb7eef11ddb$export$d73ee8ef04f5226a(language) {
    var elements = document.querySelectorAll('[data-translate]');
    elements.forEach(function(element) {
        var key = element.getAttribute('data-translate');
        var currentTranslation = (0, $2efcc2a8e9aa1010$export$2e2bcd8739ae039)[language][key];
        // console.log(currentTranslation);
        if ('attr' in currentTranslation) {
            element.setAttribute('aria-label', currentTranslation.attr);
            element.setAttribute('title', currentTranslation.attr);
        }
        if ('text' in currentTranslation) element.innerHTML = currentTranslation.text;
    });
}


'use strict';
var $ba554c72d1debec3$export$d4646ca64682bd64 = function() {
    (0, $3ad91079be1c7c57$export$734b6b18d6fd8950).classList.remove((0, $0fb798a960d623b2$export$9f6f34f6d129db5b));
    (0, $3ad91079be1c7c57$export$37fa52dd6db13025).classList.remove((0, $0fb798a960d623b2$export$6f734f043e171609));
    setTimeout(function() {
        (0, $3ad91079be1c7c57$export$734b6b18d6fd8950).style.visibility = 'hidden';
    }, (0, $0fb798a960d623b2$export$1e9ee88f033039e9)); // Затримка повинна відповідати тривалості анімації
};
var $ba554c72d1debec3$export$e9f41043288b04f8 = function() {
    (0, $3ad91079be1c7c57$export$734b6b18d6fd8950).style.visibility = 'visible';
    (0, $3ad91079be1c7c57$export$734b6b18d6fd8950).classList.add((0, $0fb798a960d623b2$export$9f6f34f6d129db5b));
    (0, $3ad91079be1c7c57$export$37fa52dd6db13025).classList.add((0, $0fb798a960d623b2$export$6f734f043e171609));
};
var $ba554c72d1debec3$export$135d2e681114b0c3 = function() {
    if (window.innerWidth < 768) {
        if ((0, $36cad142eb79f92e$export$436f07e526c01bfe)()) (0, $3ad91079be1c7c57$export$37fa52dd6db13025).classList.remove((0, $0fb798a960d623b2$export$2684fda514bedb82));
        else (0, $3ad91079be1c7c57$export$37fa52dd6db13025).classList.add((0, $0fb798a960d623b2$export$2684fda514bedb82));
    } else (0, $3ad91079be1c7c57$export$37fa52dd6db13025).classList.remove((0, $0fb798a960d623b2$export$2684fda514bedb82));
};
var $ba554c72d1debec3$var$handleLanguageButtonClick = function(e) {
    if ((0, $3ad91079be1c7c57$export$734b6b18d6fd8950).classList.contains((0, $0fb798a960d623b2$export$9f6f34f6d129db5b))) $ba554c72d1debec3$export$d4646ca64682bd64();
    else $ba554c72d1debec3$export$e9f41043288b04f8();
};
var $ba554c72d1debec3$var$handleLanguageItemClick = function(e) {
    if (e.target.tagName !== 'BUTTON') return;
    var language = e.target.getAttribute('lang');
    localStorage.setItem((0, $0fb798a960d623b2$export$72317f8505974a42), language);
    (0, $e7426fb7eef11ddb$export$d73ee8ef04f5226a)(language);
    (0, $3ad91079be1c7c57$export$37fa52dd6db13025).textContent = language.toUpperCase();
    (0, $3ad91079be1c7c57$export$3d4a40cd190e3ce0).forEach(function(item) {
        if (item === e.target) item.setAttribute('aria-selected', 'true');
        else item.setAttribute('aria-selected', 'false');
    });
    $ba554c72d1debec3$export$d4646ca64682bd64();
};
var $ba554c72d1debec3$export$f28b748eb48c0621 = function() {
    var language = localStorage.getItem((0, $0fb798a960d623b2$export$72317f8505974a42)) || (0, $0fb798a960d623b2$export$292d61dcfb6174ec);
    (0, $e7426fb7eef11ddb$export$d73ee8ef04f5226a)(language);
    (0, $3ad91079be1c7c57$export$3d4a40cd190e3ce0).forEach(function(item) {
        if (item.getAttribute('lang') === language) item.setAttribute('aria-selected', 'true');
        else item.setAttribute('aria-selected', 'false');
    });
    (0, $3ad91079be1c7c57$export$37fa52dd6db13025).textContent = language.toUpperCase();
    document.body.classList.remove((0, $0fb798a960d623b2$export$ef9d69bf459e1c38));
};
var $ba554c72d1debec3$export$e554175528f5d58d = function(e) {
    if (!(0, $3ad91079be1c7c57$export$734b6b18d6fd8950).classList.contains((0, $0fb798a960d623b2$export$9f6f34f6d129db5b)) || e.target.closest('.language-selector')) return;
    $ba554c72d1debec3$export$d4646ca64682bd64();
};
var $ba554c72d1debec3$export$acfc3dd2b37b8ba7 = function() {
    $ba554c72d1debec3$export$135d2e681114b0c3();
    window.addEventListener('resize', $ba554c72d1debec3$export$135d2e681114b0c3);
    (0, $3ad91079be1c7c57$export$37fa52dd6db13025).addEventListener('click', $ba554c72d1debec3$var$handleLanguageButtonClick);
    (0, $3ad91079be1c7c57$export$734b6b18d6fd8950).addEventListener('click', $ba554c72d1debec3$var$handleLanguageItemClick);
    document.addEventListener('click', $ba554c72d1debec3$export$e554175528f5d58d);
};





var $cf00cce96161eae6$export$a5a7a9f533393a65 = function() {
    var headerRect = (0, $3ad91079be1c7c57$export$38e42c68cf43b5d4).getBoundingClientRect();
    if (headerRect.bottom < 0) (0, $3ad91079be1c7c57$export$8110b902d5298ede).classList.add((0, $0fb798a960d623b2$export$947a61c9127a8280));
    else (0, $3ad91079be1c7c57$export$8110b902d5298ede).classList.remove((0, $0fb798a960d623b2$export$947a61c9127a8280));
};


var $6c0631df232f6ee1$export$d040aec297db8994 = function() {
    var images = document.querySelectorAll('.fade-img');
    var observerOptions = {
        root: null,
        rootMargin: '10% 50%',
        threshold: 0
    };
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) entry.target.classList.add('fade-img--visible');
            else entry.target.classList.remove('fade-img--visible');
        });
    }, observerOptions);
    images.forEach(function(image) {
        observer.observe(image);
    });
};


document.addEventListener('DOMContentLoaded', function() {
    (0, $ba554c72d1debec3$export$f28b748eb48c0621)();
    (0, $ba554c72d1debec3$export$acfc3dd2b37b8ba7)();
    (0, $36cad142eb79f92e$export$cd1ed5fb42567c5c)();
    (0, $c745b4b91eb85d3a$export$b7feb3e146f9297f)();
    window.addEventListener('scroll', (0, $cf00cce96161eae6$export$a5a7a9f533393a65));
    (0, $cf00cce96161eae6$export$a5a7a9f533393a65)(); // Викликати при завантаженні сторінки
    (0, $6c0631df232f6ee1$export$d040aec297db8994)();
});

})();
//# sourceMappingURL=index.55c0454f.js.map
